module.exports = __webpack_public_path__ + "static/media/bigcommerce_text_logo.561c1004.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connect_store/bigcommerce_text_logo.png
// module id = 1537
// module chunks = 0